import React__default from 'react';
import styled from 'styled-components';
import { Popover, Box } from '@amzn/storm-ui';
import { C as CountrySelectorContent } from './CountrySelectorContent-B6c3OozS.js';

const CountrySelectorHeader = /*#__PURE__*/styled(Box).withConfig({
  componentId: "sc-storm-ui-40025937__sc-193j8u8-0"
})(["border-radius:", ";border-bottom:", ";"], ({
  theme
}) => `${theme.border.radius.large} ${theme.border.radius.large} 0 0`, ({
  theme
}) => theme.border.subtle.default);
const CountrySelectorPopover = ({
  id,
  children,
  countries,
  exclude,
  onClose,
  onClick,
  onSelect,
  isOpen,
  trigger,
  renderHeader,
  renderOptionsStart,
  renderOptionsEnd,
  applyButtonText
}) => /*#__PURE__*/React__default.createElement(Popover, {
  align: "start",
  autoFocus: true,
  position: "bottom",
  isOpen: isOpen,
  padding: "none",
  onClick: onClick,
  onCloseButtonClick: onClose,
  trigger: /*#__PURE__*/React__default.cloneElement(trigger, {
    ...trigger.props,
    'aria-haspopup': 'dialog',
    'aria-controls': `${id}`,
    'aria-expanded': isOpen,
    id: `${id}-trigger`
  })
}, renderHeader && /*#__PURE__*/React__default.createElement(CountrySelectorHeader, {
  padding: "small base"
}, renderHeader()), /*#__PURE__*/React__default.createElement(CountrySelectorContent, {
  id: id,
  countries: countries,
  exclude: exclude,
  onClose: onClose,
  onSelect: onSelect,
  applyButtonText: applyButtonText
}, !!renderOptionsStart && /*#__PURE__*/React__default.createElement(Box, {
  padding: "small base"
}, renderOptionsStart()), children, !!renderOptionsEnd && /*#__PURE__*/React__default.createElement(Box, {
  padding: "small base"
}, renderOptionsEnd())));

export { CountrySelectorPopover as C };
//# sourceMappingURL=CountrySelectorPopover-B-2Q6EK8.js.map
